import React, { useEffect, useState } from "react";
import { Typography, Card, CardContent } from "@material-ui/core";
import rest from "../../rest";
import { useHistory } from "react-router-dom";

import AffichageSelctDate, {
  sorteGroupeActivity,
} from "../../components/inscriptionWish/ChoixDates/AfficheDateSelected";

import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
import { Alert, AlertTitle } from "@material-ui/lab";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

const Planning = () => {
  const [loading, setLoading] = useState(false);
  const [activites, setActivites] = useState([]);
  const [groupedActivities, setGroupedActivities] = useState({});
  const [status, setStatus] = useState("");
  const [snack, setSnack] = useState({});
  const history = useHistory();

  // Recup le planning
  useEffect(() => {
    setLoading(true);
    rest
      .get("/benevols/planning.json")
      .then((response) => {
        setGroupedActivities(sorteGroupeActivity(response.data.tranches));
        setStatus(response.data.statut);
        setActivites(response.data.choixActivites);
        if (response.data.statut === "valider") {
          history.push("/mes_activites.html");
        }
        setLoading(false);
      })
      .catch((error) => {
        setSnack({ message: "/benevols/planning.json " + error, show: true, severity: "error", });
      });
  }, [history]);

  // Affichge du message en fonction du status
  const getAlert = (status) => {
    switch (status) {
      case "En attente":
        return (
          <Alert severity="info" icon={false}>
            <AlertTitle style={{ fontWeight: "bold" }}>
              Statut : En attente de traitement
            </AlertTitle>
            Merci pour votre inscription ! Votre demande sera prise en charge
            dans les meilleurs délais.
          </Alert>
        );
      case "prevalider":
        return (
          <Alert severity="success">
            <AlertTitle style={{ fontWeight: "bold" }}>
              Statut : Planning pré-validé (non définitif)
            </AlertTitle>
            Nous avons le plaisir de vous informer que votre inscription a été
            retenue pour :{" "}
            <span style={{ fontWeight: "bold" }}>
              {getFirstActivityName()}
              {". "}
            </span>
            Vos horaires définitifs vous seront communiqués prochainement.
          </Alert>
        );
      case "valider":
        return (
          <Alert severity="success">
            <AlertTitle style={{ fontWeight: "bold" }}>
              Statut : Planning validé (définitif)
            </AlertTitle>
            Votre planning a été finalisé. Vous pouvez maintenant consulter vos
            horaires définitifs.
          </Alert>
        );
      case "reatribution":
        return (
          <Alert severity="warning">
            <AlertTitle style={{ fontWeight: "bold" }}>
              Statut : Réattribution
            </AlertTitle>
            Vous avez été réattribué dans{" "}
            <span style={{ fontWeight: "bold" }}>
              {getFirstActivityName()}
              {". "}
            </span>
            Votre inscription sera prise en charge par le responsable dans les
            meilleurs délais.
          </Alert>
        );
      case "desistement":
        return (
          <Alert severity="info" icon={false}>
            <AlertTitle style={{ fontWeight: "bold" }}>
              Statut : Désistement
            </AlertTitle>
            Nous avons bien pris en compte votre désistement. Votre demande
            d'inscription pour cette édition a été annulée.
          </Alert>
        );
      case "Liste d'attente":
        return (
          <Alert severity="error" icon={false}>
            <AlertTitle style={{ fontWeight: "bold" }}>Statut : Liste d'attente</AlertTitle>
            Nous regrettons de vous informer que votre demande d'inscription n'a
            pas pu être retenue pour les activités souhaitées. Vous êtes
            actuellement sur notre liste d'attente. Vous serez contacté en cas
            de réattribution.
          </Alert>
        );
      default:
        return null;
    }
  };

  // Affiche le nom de la première activité non refusée
  const getFirstActivityName = () => {
    if (activites.find((a) => a?.reattribuer === true)) {
      if (status === "reatribution" || status === "prevalider") {
        return activites.find((a) => a?.treated === false)?.nom;
      }
      return activites.find((a) => a?.reattribuer === true)?.nom;
    }

    return activites.find((a) => a?.refus !== true)?.nom;
  };

  return (
    <>
      <LoadingIndicator loading={loading} />
      {!loading && (
        <>
          <MySnackbar params={snack} />
          <Card elevation={3}>
            <CardContent>
              {getAlert(status)}
              <Typography
                variant="h5"
                style={{ marginTop: 20, marginBottom: 10 }}
              >
                Disponibilités
              </Typography>
              <AffichageSelctDate
                firstActivity={getFirstActivityName()}
                activitesInfos={activites}
                groupedActivities={groupedActivities}
                showTreated={false}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default Planning;
